import { render, staticRenderFns } from "./subdivisionsEdit.vue?vue&type=template&id=2732c2dd&scoped=true&"
import script from "./subdivisionsEdit.vue?vue&type=script&lang=js&"
export * from "./subdivisionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2732c2dd",
  null
  
)

export default component.exports